import React, { useState,useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from 'axios';

import { useRecoilState } from "recoil";
import { BranchMenus } from "../../components/recoil/atoms/Menus";

import HeaderBranchTitle from "../components/includes/HeaderBranchTitle";
import { ChangeSimpleDateString,LoginAfterCheckLogin } from "../../components/common/Common";
import arrowIcon from "../../img/icon/icon-arrow-right-g.svg";
import "../../css/style.css";

//비밀번호 찾기
const SemesterSet = () => {
  LoginAfterCheckLogin(2);  //로그인 상태 점검\
  const branch_idx = Number(localStorage.getItem('branch_idx'));
  const navigate = useNavigate();

  const [varBranchMenus,setBranchMenus] = useRecoilState(BranchMenus);

  const [varTotalCount,setTotalCount] = useState(0);
  const [varSemesterList,setSemesterList] = useState([]);
  const [varSearchName,setSearchName] = useState("");

  //표시할 학기모드
  const [varSemesterMode,setSemesterMode] = useState(2);

  //학기내역 가져오기
  const GetSemesterList = async() => {
    const sendData = {branch_idx:branch_idx,smode:varSemesterMode,searchName:varSearchName};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/branch_get_semester_list`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
      if(datas.retvalue === 1) {
        setTotalCount(datas.results.length);
        if(datas.results.length > 0) setSemesterList(datas.results);
        else setSemesterList([]);
      } else {
        setSemesterList([]);
      }
    });
  }

  //최초실행부
  useEffect(() => {
    console.log(varBranchMenus);
    setBranchMenus({showMenu:true,gotoMain:1});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //학기모드가 바뀌면
  useEffect(() => {
    GetSemesterList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [varSemesterMode]);

  //검색명
  const onChangeSearchNameHandler = (e) => {
    const sname = e.currentTarget.value;
    setSearchName(sname);
  }
  //검색시작
  const onSearchHandler = (e) => {
    e.preventDefault();
    if(varSearchName === "") {
      alert('검색할 원생명이나 학부모명을 먼저 입력하세요.'); return false;
    }
  }

  //학기종류선택
  const onSelectSemesterHandler = (e,imode) => {
    setSemesterMode(imode);
  }
  //복사
  const onCopySemesterHandler = (e,sm_idx) => {
    navigate(`/Branch/SemesterCopy/${sm_idx}`);
  }
  
  return (
    <div className="vh-content sem-setting-wrap">
      <HeaderBranchTitle varPageTitle={'학기 설정'} varBackString={'/Branch/Setting'}/>
      <div className="vh-content-body">
        <div className="cl-search-form">
          <div className="center-wrap">
            <div className="sem-sort-tab">
              {/* 학기선택 */}
							<ul>
								<li className={varSemesterMode===0?"on":""}><button className="button st02" onClick={e=>onSelectSemesterHandler(e,0)}>종료</button></li>
								<li className={varSemesterMode===2?"on":""}><button className="button st02" onClick={e=>onSelectSemesterHandler(e,2)}>진행중</button></li>
								<li className={varSemesterMode===1?"on":""}><button className="button st02" onClick={e=>onSelectSemesterHandler(e,1)}>예정</button></li>
							</ul>
						</div>
            {/* 원생/학부모 검색 */}
            <div className="search-wrap">
							<input type="text" name="search_name" className="search-input" placeholder="원생명, 학부모명으로 검색" value={varSearchName} onChange={e=>onChangeSearchNameHandler(e)}/>
							<button type="button" onClick={e=>onSearchHandler(e)}>검색</button>
						</div>
            <div className="search-ok-con">
              <div className="top-line2">
								<p>전체 {varTotalCount}건</p>
								<Link to={"/Branch/SemesterDetail/0"}>학기 추가</Link>
							</div>
              {varSemesterList.map((semester,i)=>(
                <div key={'semester_'+i} className="con-box">
                  <button className="semester-copy" onClick={e=>onCopySemesterHandler(e,semester.sm_idx)}>학기복사</button>
                  <p>{semester.sm_name}</p>
                  <Link to={`/Branch/SemesterDetail/${semester.sm_idx}`} className="btn-setting2"><img src={arrowIcon} alt="" /></Link>
                  <div className="txt-box">
                    <div className="flex">
                      <p>개강일</p>
                      <div>{ChangeSimpleDateString(semester.sm_sdate)}</div>
                      <p>종강일</p>
                      <div style={{marginRight:"0px"}}>{ChangeSimpleDateString(semester.sm_edate)}</div>
                    </div>
                    <div className="flex">
                      <p>등록일</p>
                      <div>{ChangeSimpleDateString(semester.sm_rdate)}</div>
                    </div>
                    <div className="flex">
                      <p>상태</p>
                      <div>{semester.sm_status===2?"진행중":semester.sm_status===1?"예정":"종료"}</div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>	
  );
}
export default SemesterSet;